exports.components = {
  "component---src-templates-guide-js": () => import("./../../../src/templates/guide.js" /* webpackChunkName: "component---src-templates-guide-js" */),
  "component---src-templates-snippet-js": () => import("./../../../src/templates/snippet.js" /* webpackChunkName: "component---src-templates-snippet-js" */),
  "component---src-templates-snippet-links-js": () => import("./../../../src/templates/snippet_links.js" /* webpackChunkName: "component---src-templates-snippet-links-js" */)
}

